export const MAX_VISIBLE_PILLS_COLLAPSED = 3;
export const MAX_DISPLAY_PILLS = 8;
